module.exports = __webpack_public_path__ + "img/map_enabled.10543e1c.svg";